import { Link } from "@/i18n/navigation";
import Image from "next/image";
import { ComponentProps } from "react";

type YoutubeVideoProps = ComponentProps<typeof Image> &
  ComponentProps<typeof Link> & {
    title: string;
    text: string;
  };

const YoutubeVideo = ({ ...props }: YoutubeVideoProps) => {
  return (
    <div className="gs--blog-video cursor-pointer border p-4 text-center shadow-lg transition-all duration-300 hover:scale-[1.05]">
      <Link href={props.href} target="_blank" rel="noopener noreferrer">
        <Image
          className="gs--blog-video__thumbnail rounded-lg"
          src={props.src}
          alt={props.alt}
          width={400}
          height={300}
        />

        <div className="flex flex-col gap-2">
          <span className="text-primary bg-primary/20 border-primary my-3 rounded-full border px-2 py-1 leading-none uppercase">
            {props.title}
          </span>

          <span className="text-ring">{props.text}</span>
        </div>
      </Link>
    </div>
  );
};

export default YoutubeVideo;
